module.exports = __webpack_public_path__ + "static/the-harmless-people-36d9735b6b88652fd241ee38be30bd5d.jpg";